module.exports = __webpack_public_path__ + "img/strike-red.302da718.svg";